import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";

import HomePage from "@/pages/HomePage";
import GalleryPage from "@/pages/GalleryPage";
import RoomsPage from "@/pages/RoomsPage";
import ExperiencePage from "@/pages/ExperiencePage";
import BookingPage from "@/pages/BookingPage";
import ContactPage from "@/pages/ContactPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DashboardPage from "@/pages/DashboardPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const Layout = ({ children, hideChrome = false }) => (
  <>
    {!hideChrome && <Navbar />}
    {children}
    {!hideChrome && <Footer />}
    {!hideChrome && <WhatsAppButton />}
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <AuthProvider>
            <ScrollToTop />
            <Toaster position="top-right" theme="light" />
          <Routes>
            <Route path="/" element={<Layout><HomePage /></Layout>} />
            <Route path="/gallery" element={<Layout><GalleryPage /></Layout>} />
            <Route path="/rooms" element={<Layout><RoomsPage /></Layout>} />
            <Route path="/experience" element={<Layout><ExperiencePage /></Layout>} />
            <Route path="/booking" element={<Layout><BookingPage /></Layout>} />
            <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
            <Route path="/login" element={<Layout hideChrome><LoginPage /></Layout>} />
            <Route path="/register" element={<Layout hideChrome><RegisterPage /></Layout>} />
            <Route path="/dashboard" element={<Layout><DashboardPage /></Layout>} />
          </Routes>
        </AuthProvider>
      </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
